'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["metaData"];
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { addDependentField as addDependentFieldFromAction, editDependentField as editDependentFieldFromAction, removeDependentField as removeDependentFieldFromAction } from 'FormsUI/actions/FormSmartOptions';
import { update as updateFromAction } from 'FormsUI/actions/Field';
import { canBeProfilled, canAddDependent } from 'FormsUI/selectors/Field';
import { PropertyObjectTypes, PropertyObjectTypesIds } from 'FormsCommonComponents/js/constants/PropertyObjectTypes';
import { getDependentFieldsWithParent, getDependentFieldForId } from 'FormsUI/selectors/FormSmartOptions';
import { getFormFieldsByPropertyId, getFormFieldGroupForFormField } from 'FormsUI/selectors/FormDefinition';
import { hasProgressiveProfillingAccess, hasDependentFieldsAccess } from 'FormsUI/selectors/Scope';
import { getPropertiesForForm } from 'FormsUI/selectors/Properties';
import { isFormLabelPropertyEnabled } from 'forms-utils-lib/settings/selectors';
import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import { getFormMetaData } from 'FormsUI/selectors/FormDefinition';
import { findMetaDataKey } from 'FormsCommonComponents/form-definition/utils/MetaDataUtils';
import { DISABLE_COOKIE_SUBMISSION } from 'FormsCommonComponents/form-definition/constants/MetaDataKeys';
import { getUserPreferredLocale } from 'FormsUI/selectors/UserPreferences';
import LogicConfig from './LogicConfig';
import { VIEW_LOGIC_CONFIG } from 'FormsUI/constants/TrackingInteractionKeys/Editor/FormTab';
import { jsx as _jsx } from "react/jsx-runtime";
const LogicConfigContainer = props => {
  useEffect(() => void trackEditorInteraction(VIEW_LOGIC_CONFIG), []);
  const {
      metaData
    } = props,
    remainingProps = _objectWithoutPropertiesLoose(props, _excluded);
  const isCookieTrackingDisabled = findMetaDataKey(metaData, DISABLE_COOKIE_SUBMISSION);
  return /*#__PURE__*/_jsx(LogicConfig, Object.assign({
    isCookieTrackingDisabled: isCookieTrackingDisabled
  }, remainingProps));
};
const mapStateToProps = (state, props) => {
  const dependentField = getDependentFieldForId(state, props);
  const isContactProperty = props.formField.objectTypeId === PropertyObjectTypesIds[PropertyObjectTypes.CONTACT];
  return {
    metaData: getFormMetaData(state),
    dependentField,
    shouldShowDependentFields: canAddDependent(state),
    shouldShowProgressive: canBeProfilled(state) && isContactProperty,
    numberFormFieldsWithinGroup: (getFormFieldGroupForFormField(state, props).fields || []).length,
    mainAndQueuedFieldsByPropertyId: getFormFieldsByPropertyId(state),
    dependentFieldsByPropertyId: getDependentFieldsWithParent(state),
    propertiesById: getPropertiesForForm(state),
    isFormLabelPropertyEnabled: isFormLabelPropertyEnabled(state),
    haveAccessToLogicConfig: hasProgressiveProfillingAccess(state) || hasDependentFieldsAccess(state),
    userPreferredLocale: getUserPreferredLocale(state)
  };
};
const actionsToBind = {
  addDependentField: addDependentFieldFromAction,
  editDependentField: editDependentFieldFromAction,
  removeDependentField: removeDependentFieldFromAction,
  updateFormField: updateFromAction
};
export default connect(mapStateToProps, actionsToBind)(LogicConfigContainer);